@use '@/shared/styles/settings' as settings;
@use '@/shared/styles/theme' as *;

.employee-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: var(--space-6);
  background-color: var(--app-surface);
  border: 1px solid var(--app-border);
  border-radius: var(--radius-panel);
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--neutral_600);
    background-color: var(--app-surface-muted);
  }
}

.header-main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);

  .avatar {
    flex-shrink: 0;
    width: 35px;
    height: 35px;
    border-radius: var(--radius-panel);
    border: 1px solid var(--app-border);
  }

  .avatar-frame {
    position: relative;
    flex-shrink: 0;
    width: 35px;
    height: 35px;
    border-radius: var(--radius-panel);
    overflow: hidden;
    border: 1px solid var(--app-border);
    background: var(--app-surface-muted);
  }

  .avatar-skeleton {
    @include avatar-skeleton-layer(9px);
  }

  .avatar-image {
    @include avatar-fade-in-image(9px);
  }

  .avatar-image--visible {
    @include avatar-fade-in-image-visible;
  }

  div.avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--app-border);
    @include settings.heading;
    color: var(--primary_text);
  }
}

.header-left {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.header-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.name {
  @include settings.heading;
  color: var(--primary_text);
  margin: 0;
}

.nameRow {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.onlineDot {
  display: inline-block;
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 999px;
  background: var(--status-success-fg);
}

.meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.email {
  @include settings.body;
  color: var(--secondary_text);
}

.nickname {
  @include settings.body;
  color: var(--secondary_text);
  font-style: italic;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.label {
  @include settings.body;
  color: var(--secondary_text);
  flex-shrink: 0;
  min-width: 112px;
}

.value {
  @include settings.body;
  color: var(--primary_text);
  flex: 1;
  overflow-wrap: anywhere;
  min-width: 0;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--space-4);
}
.email {
  overflow-wrap: anywhere;
}
@media (max-width: 600px) {
  .employee-card {
    padding: var(--space-4);
  }
  .info-row {
    flex-direction: column;
    gap: var(--space-1);
  }
}
